import { render, staticRenderFns } from "./busca-expedM.vue?vue&type=template&id=6bdf0584"
import script from "./busca-expedM.vue?vue&type=script&lang=js"
export * from "./busca-expedM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports